
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DirectorySearch extends Vue {
  @Prop(String) readonly placeholder!: string;
  keyword: string = "";

  handleSearch() {
    this.$emit("search", this.keyword);
  }
}
